export function getProductVariantImage(productVariant) {
    return getProductImage(productVariant) || getProductImage(productVariant?.product);
}

export function getProductImage(product) {
    return product?.imageSrc || product?.imageUrl || product?.product?.imageSrc || product?.product?.imageUrl;
}

export function getProductImages(p) {
    if (p?.imageSrcs) {
        return p?.imageSrcs?.slice(0, 10);
    }
    const image = p?.imageSrc || p?.imageUrl;
    if (image) {
        return [image];
    }
    return [];
}

export function getProductId(product) {
    return product?.id;
}

export function getProductTitle(product) {
    return product?.title;
}

export function getProductVariantTypes(product) {
    return product?.variantTypes;
}

export function getProductStatistics(product) {
    return product?.statistics;
}

export function getProductReturns(productData) {
    return productData?.returnItems || 0;
}

export function getProductExchangesFrom(productData) {
    return productData?.exchangeItemsFrom || productData?.exchangeItems || 0;
}

export function getProductComplaints(productData) {
    return productData?.complaintItems || 0;
}

export function getProductOrders(productData) {
    return productData?.orderItems;
}

function formatFn(value) {
    return Math.round(value * 100);
}

export function getProductReturnsInPercentage(productData, { format = false } = {}) {
    const value = productData?.returnRate || 0;
    return format ? formatFn(value) : value;
}

export function getProductReturnsWorthInPercentage(productData, { format = false } = {}) {
    const value = (productData?.returnItemsWorth || 0) / (productData?.orderItemsWorth || 0);
    return format ? formatFn(value) : value;
}

export function getProductExchangeWorthInPercentage(productData, { format = false } = {}) {
    const value = (productData?.exchangeItemsWorth || 0) / (productData?.returnItemsWorth || 0);
    return format ? formatFn(value) : value;
}

export function getProductComplaintWorthInPercentage(productData, { format = false } = {}) {
    const value = (productData?.complaintItemsWorth || 0) / (productData?.returnItemsWorth || 0);
    return format ? formatFn(value) : value;
}

export function getProductGiftCardWorthInPercentage(productData, { format = false } = {}) {
    const value = (productData?.giftCardsCreatedWorth || 0) / (productData?.refundTransactionsWorth || 0);
    return format ? formatFn(value) : value;
}

export function getProductExchangesFromInPercentage(productData, { format = false }) {
    const value = productData?.exchangeRate || 0; //getProductExchangesFrom(productData) / (getProductReturns(productData) || 1);
    return format ? formatFn(value) : value;
}

export function getProductComplaintsInPercentage(productData, { format = false }) {
    const value = productData?.complaintRate || 0;
    return format ? formatFn(value) : value;
}

export function getProductNumberOfReturnPolicies(product) {
    return product?.numberOfReturnPolicies;
}

export function productsHasAnyPolicies(products) {
    return !!products?.find((p) => !!getProductNumberOfReturnPolicies(p));
}
